import { roles } from "constants/index";

export const rolesGetAllShop = [roles.qs, roles.regionManager]